import React, { useState, useEffect } from "react";


type props = {
    apiUrl: string;
    data: any;
    onLoading: (arg: boolean) => any;
    onError: (arg: string) => any;
    onResult: (arg: any) => any;
}

const useFetchPost = async ({ apiUrl, data, onLoading, onError, onResult }: props) => {
    try {
        onLoading(true);
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`Ошибка ${response.status}: ${response.statusText}`);
        }
        const result = await response.json();
        console.log(result);
        onResult(result);
    } catch (err) {
        console.log(err.message);
        onError(err.message);
    } finally {
        onLoading(false);
    }

}

export default useFetchPost;